const ExportDocumentToolsGridPluginSettings: IPluginSettings = {
    name: 'Настройка экспорта документов',
    mnemocode: 'export_document_tools_model_plugin',
    permission: 'ExportDocument',
    columns: [
        {
            order: 0,
            propertyName: 'idGlobal',
            propertyType: 'string',
            displayName: 'idGlobal',
            visibility: false,
            width: 150
        },{
            order: 1,
            propertyName: 'name',
            propertyType: 'string',
            displayName: 'Наименование',
            visibility: true,
            width: 200
        },
        {
            order: 2,
            propertyName: 'encoding',
            propertyType: 'string',
            displayName: 'Кодировка',
            visibility: true,
            width: 200
        },
        {
            order: 3,
            propertyName: 'dateCreated',
            propertyType: 'datetime',
            displayName: 'Дата создания',
            visibility: false,
            width: 200
        },
        {
            order: 4,
            propertyName: 'dateModified',
            propertyType: 'datetime',
            displayName: 'Дата последнего изменения',
            visibility: false,
            width: 200
        },
        {
            order: 5,
            propertyName: 'dateDeleted',
            propertyType: 'datetime',
            displayName: 'Дата удаления',
            visibility: false,
            width: 200
        }
    ]
}

export default ExportDocumentToolsGridPluginSettings